<template>
  <b-dropdown
    variant="link"
    toggle-class="btn-more-info text-decoration-none btn-sm"
    :right="right"
  >
    <template v-slot:button-content>
      <i class="material-icons">
        more_horiz
      </i>
    </template>
    <b-dropdown-item v-if="permiteEditar" @click="onEditar(item)" >
      {{ $t("label.editar") }}
    </b-dropdown-item>
    <b-dropdown-item-button
      :variant="`${item[ativoProp] ? 'danger' : 'success'}`"
      @click="onToogle(item, item[ativoProp])"
    >
      {{ item[ativoProp] ? $t("label.remover") : $t("label.ativar") }}
    </b-dropdown-item-button>
  </b-dropdown>
</template>
<script>
export default {
  name: "AcoesDropDown",
  props: {
    ativoProp: {
      type: String,
      default: 'ativo'
    },
    idProp: {
      type: String,
      default: 'id'
    },
    item: {
      type: Object,
      required: true
    },
    permiteEditar: {
      type: Boolean,
      default: true
    },
    right: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    onEditar (item) {
      this.$emit('editar', item)
    },
    onToogle (item, status) {
      /**
       * Se o botao ativar/ inativar foi clicado
       * @emits toogle
       * @property {status} true para remover , false para ativar
       */
      this.$emit('toogle',{ item, status } )
    }
  }
};
</script>
